import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import information from '../views/information.vue'
import login from '../views/loginRegister.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'SSL证书购买'
    }
  },
    {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '登录注册'
    }
  },
  {
    path: '/information',
    name: 'information',
    component: information,
    meta: {
      title: '申请证书'
    }
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
